import {
  useWSModal,
  useWSSnackbar,
  WSActions,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

import { queriesSharedFileRequests } from "../../../../../v3/query/queriesSharedFileRequests";

interface SubmitInvalidFileModalProps {
  onClose: (result?: any) => void;
  onSubmit: () => void;
  sharedFileRequestId: string;
}

const SubmitFileModal: React.FC<SubmitInvalidFileModalProps> = ({
  onClose,
  onSubmit,
  sharedFileRequestId
}) => {
  const [submitSharedFileRequest] =
    queriesSharedFileRequests.submitSharedFileRequest.useMutation();
  const { openSnackbar } = useWSSnackbar();

  return (
    <WSList gap="L">
      <WSText.ParagraphSm>
        Are you sure you want to submit the invalidated file anyway for review?
      </WSText.ParagraphSm>
      <WSInfoBox>
        <WSText.ParagraphSm weight="medium">Important:</WSText.ParagraphSm>
        <WSText.ParagraphSm mt="XS">
          If you choose to continue with an invalidated file, it could
          ultimately be rejected by the client and result in delays in your
          onboarding and payment.
        </WSText.ParagraphSm>
      </WSInfoBox>
      <WSActions
        buttons={[
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: onClose
          },
          {
            kind: "Primary",
            label: "Submit for review",
            onAsyncClick: async () => {
              const updatedSharedFile = await submitSharedFileRequest(
                {
                  sharedFileRequestId
                },
                {
                  onError: () => {
                    openSnackbar({
                      message: "Failed to submit shared file",
                      type: "error"
                    });
                  },
                  throwOnError: true
                }
              );
              if (updatedSharedFile) {
                // requirement/engagement cache invalidation is declared on
                // the registry mutation's `dependencies`
                openSnackbar({
                  message: "File submitted successfully",
                  type: "success"
                });

                onSubmit();
                onClose(true);
                return;
              }
            }
          }
        ]}
      />
    </WSList>
  );
};

export function useSubmitSharedFileModal() {
  return useWSModal(SubmitFileModal, {
    title: "Submit for review",
    size: "S"
  });
}
